import './styles/Loader.css';

function Loader(){
    return(
        <div className="loader-container">
            <h1>Loading 
                <span className="span1">. </span>
                <span className="span2">. </span>
                <span className="span3">. </span>
            </h1>
        </div>
    );
} 

export default Loader;